import I1 from "../img/i1.png";
import F1 from "../img/f1.png";
import C3 from "../img/c3.png";
import Fi1 from "../img/fi1.png";

export const heroData = [
  {
    id: 1,
    name: "Icecream",
    decp: "Helado de Frutas",
    price: "15",
    imageSrc: I1,
  },
  {
    id: 2,
    name: "Frutillas",
    decp: "Frutillas Frescas (lb)",
    price: "10",
    imageSrc: F1,
  },
  {
    id: 3,
    name: "Chicken Kebab",
    decp: "Plato de kebab mixto",
    price: "25",
    imageSrc: C3,
  },
  {
    id: 4,
    name: "Fish Kebab",
    decp: "Kebab de Pescado Mixto",
    price: "25",
    imageSrc: Fi1,
  },
];

export const categories = [
  {
    id: 1,
    name: "Pasteleria",
    urlParamName: "pasteleria",
  },
  {
    id: 2,
    name: "CupCakes",
    urlParamName: "cupCakes",
  },
  {
    id: 3,
    name: "Chocolates",
    urlParamName: "chocolates",
  },
  {
    id: 4,
    name: "Decoracion de eventos",
    urlParamName: "eventos",
  },
  {
    id: 5,
    name: "Catering",
    urlParamName: "catering",
  },
];